/**
 * "You may also like" (sections/product-recommendations.liquid) on phones: the grid becomes a sideways row (CSS);
 * this adds position dots like the other mobile sliders, keeps the active dot on the card at the left edge, and
 * scrolls to exactly that card when a dot is tapped. The dots are hidden from 750px (CSS).
 * Recommendations arrive after page load, so lists are picked up whenever they appear.
 */
(() => {
  if (window.iglooRecsSlider) return;
  window.iglooRecsSlider = true;

  const LIST = '[data-testid="resource-list-grid"]';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const enhance = (list) => {
    if (list.dataset.iglooDots) return;
    const items = Array.from(list.querySelectorAll(':scope > .resource-list__item'));
    if (items.length < 2) return;
    list.dataset.iglooDots = '1';

    const dots = document.createElement('div');
    dots.className = 'igloo-recs-dots';
    items.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'igloo-recs-dots__dot';
      dot.setAttribute('aria-label', `Go to product ${i + 1} of ${items.length}`);
      dot.addEventListener('click', () => {
        const pad = parseFloat(getComputedStyle(list).paddingLeft) || 0;
        const left = list.scrollLeft + (items[i].getBoundingClientRect().left - list.getBoundingClientRect().left) - pad;
        list.scrollTo({ left: Math.min(left, list.scrollWidth - list.clientWidth), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      });
      dots.appendChild(dot);
    });
    list.after(dots);

    const buttons = Array.from(dots.children);
    let frame = null;
    const update = () => {
      frame = null;
      const max = list.scrollWidth - list.clientWidth;
      let active = 0;
      if (max > 0 && list.scrollLeft >= max - 2) {
        active = items.length - 1;
      } else {
        const start = list.getBoundingClientRect().left + (parseFloat(getComputedStyle(list).paddingLeft) || 0);
        let best = Infinity;
        items.forEach((item, i) => {
          const distance = Math.abs(item.getBoundingClientRect().left - start);
          if (distance < best) {
            best = distance;
            active = i;
          }
        });
      }
      buttons.forEach((b, i) => (i === active ? b.setAttribute('aria-current', 'true') : b.removeAttribute('aria-current')));
    };
    // Safety net for snapping: if a swipe gets interrupted (e.g. a card's photo gallery setting itself up on the
    // first touch), settle on the nearest card once scrolling has been still for a moment.
    let idle = null;
    let touching = false;
    list.addEventListener('touchstart', () => { touching = true; clearTimeout(idle); }, { passive: true });
    const release = () => { touching = false; clearTimeout(idle); idle = setTimeout(settle, 150); };
    list.addEventListener('touchend', release, { passive: true });
    list.addEventListener('touchcancel', release, { passive: true });
    const settle = () => {
      if (touching || !window.matchMedia('(max-width: 749px)').matches) return;
      const max = list.scrollWidth - list.clientWidth;
      if (list.scrollLeft <= 1 || list.scrollLeft >= max - 1) return;
      const pad = parseFloat(getComputedStyle(list).paddingLeft) || 0;
      const base = list.getBoundingClientRect().left + pad;
      const targets = items.map((item) => Math.min(max, list.scrollLeft + item.getBoundingClientRect().left - base));
      const nearest = targets.reduce((a, b) => (Math.abs(b - list.scrollLeft) < Math.abs(a - list.scrollLeft) ? b : a));
      if (Math.abs(nearest - list.scrollLeft) > 1) list.scrollTo({ left: nearest, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    };

    list.addEventListener('scroll', () => {
      if (!frame) frame = requestAnimationFrame(update);
      clearTimeout(idle);
      idle = setTimeout(settle, 150);
    }, { passive: true });
    update();
  };

  const scan = (root) => root.querySelectorAll(`product-recommendations ${LIST}, ${LIST}`).forEach((list) => {
    if (list.closest('product-recommendations')) enhance(list);
  });

  const start = () => {
    document.querySelectorAll('product-recommendations').forEach((el) => {
      scan(el);
      new MutationObserver(() => scan(el)).observe(el, { childList: true, subtree: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
